<template>
  <form>
    <v-layout wrap>
      <v-flex xl8 lg8 md8>
        <v-layout row wrap>
          <v-flex px-1>
            <v-autocomplete
              v-model="puntoDa"
              prepend-icon="fas fa-map-marker-alt"
              :filter="filterDa"
              :rules="rules"
              :items="tratteDa"
              clearable
              hide-selected
              item-value="id_via_p"
              label="Punto partenza"
              color="tree"
              >
                <template v-slot:selection="data">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="data.item.citta_p"></v-list-tile-title>
                        <v-list-tile-sub-title class="text-wrap text-truncate" v-html="data.item.via_p"></v-list-tile-sub-title>
                      </v-list-tile-content> 
                </template>
                <template v-slot:item="data">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="data.item.citta_p"></v-list-tile-title>
                        <v-list-tile-sub-title class="text-wrap text-truncate" v-html="data.item.via_p"></v-list-tile-sub-title>
                      </v-list-tile-content>   
                </template>
            </v-autocomplete>
          </v-flex>
          <v-flex px-1>
            <v-autocomplete
              v-model="puntoA"
              :filter="filterA"
              prepend-icon="fas fa-map-marker-alt"
              :rules="rules"
              :items="tratteA"
              clearable
              hide-selected
              item-value="id_via_d"
              label="Punto arrivo"
              color="tree"
              >
                <template v-slot:selection="data">
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.citta_d"></v-list-tile-title>
                    <v-list-tile-sub-title class="text-wrap" v-html="data.item.via_d"></v-list-tile-sub-title>
                  </v-list-tile-content>   
                </template>
                <template v-slot:item="data">
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.citta_d"></v-list-tile-title>
                    <v-list-tile-sub-title class="text-wrap" v-html="data.item.via_d"></v-list-tile-sub-title>
                  </v-list-tile-content> 
                </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex d-flex px-2 justify-space-between>
              <v-spacer></v-spacer>
            <span class="title font-italic font-weight-medium">{{chilometraggio}} Km</span>
            <v-icon>forward</v-icon>
            
            <v-badge              
              right
              color="white"
              class="title font-italic font-weight-medium text-xs-right"
            >
              <template slot="badge">
                  <v-tooltip right>
                      <template slot="activator">
                        <v-icon color="blue lighten-1" small >fas fa-info</v-icon>
                      </template>
                      <span>Importo potrà variare in base al valore ACII attuale</span>
                  </v-tooltip>

              </template>
                {{importo}} Euro
            </v-badge>
            <v-spacer></v-spacer>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex align-center xl4 lg4 md4>
        <v-select
          prepend-icon="fas fa-exchange-alt"
          :rules="rules"
          v-model="trattaTipo"
          :items="trattaType"
          item-text="titolo"
          item-value="id"
          label="Tipo Tratta"
          color="tree"
          @change="$emit('setTrattaTipo', $event)"
        ></v-select>
      </v-flex>
    </v-layout>
  </form>
</template>
<script>
export default {
  name: "acc-form-tratta",
  props: {
    tariff: {
      type: Number,
      required: true
    },
    koeff: {
      type: Number,
      required: true
    },
    rules: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    puntoDa: null,
    puntoA: null,
    trattaTipo: "1",
    tariffTemp: 0
  }),
  watch: {
    importo(val) {
      this.$emit("setAutoImporto", val);
    },
    koeff(val) {
      this.tariffTemp = 0;
    },
    tariff(val) {
      this.tariffTemp = val;
    },
    tratta(val) {
      this.$emit("setTratta", val);
    },
  },
  created() {
    this.tariffTemp = this.tariff;
  },
  computed: {
    trattaType() {
      return this.$store.getters.getPageData.trattaType;
    },
    tratte() {
      return this.$store.getters["notaSpese/tratte"];
    },
    tratta() {
        if (this.puntoDa && this.puntoA) {
            return this.tratte.find(tr => (this.puntoDa == tr.id_via_p && this.puntoA == tr.id_via_d)).id
        } else {
            return null;
        }
    },
    tratteDa() {
      return this.tratte.filter(tr => {
          return this.puntoA ? this.puntoA == tr.id_via_d : true;
      }).sort((a, b) => {
        if (a.citta_p > b.citta_p) {
            return 1;
        }
        if (b.citta_p > a.citta_p) {
            return -1;
        }
        return 0;
      });
    },
    tratteA() {
      return this.tratte.filter(tr => {
          return this.puntoDa ? this.puntoDa == tr.id_via_p : true;
      }).sort((a, b) => {
        if (a.citta_d > b.citta_d) {
            return 1;
        }
        if (b.citta_d > a.citta_d) {
            return -1;
        }
        return 0;
      });
    },
    chilometraggio() {
      const trattaMolt = this.trattaType.find( tt => (tt.id === this.trattaTipo) )
      const tratta = this.tratte.find( tr => (tr.id == this.tratta) )
      
      return tratta
        ? ((tratta.km || 0) * (trattaMolt.moltiplicatore || 0)).toFixed(0)
        : 0;
    },
    importo() {
      return (
        this.chilometraggio * this.tariffTemp +
        this.chilometraggio * this.tariffTemp * this.koeff
      ).toFixed(2);
    }
  },
  methods: {
    cleanDialogForm() {
      this.puntoDa = null
      this.puntoA = null
      this.trattaTipo = "1"
    },
    filterDa (item, val) {
        return item.via_p.toLowerCase().includes(val.toLowerCase()) || item.citta_p.toLowerCase().includes(val.toLowerCase())
    },
    filterA (item, val) {
        return item.via_d.toLowerCase().includes(val.toLowerCase()) || item.citta_d.toLowerCase().includes(val.toLowerCase())
    }
  }
};
</script>

<style lang="scss">
.btn-row-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.v-input__control {
    overflow: hidden!important;
    text-overflow: ellipsis!important;
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/FormTratta.vue